import { api, ApiRoutes } from './ApiService';
import { Email } from '../types/Email';

export interface EmailPagination {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
}

export interface FetchEmailsResponse {
    emails: Email[];
    pagination?: EmailPagination;
}

export const fetchEmails = async (page: number = 1, limit: number = 10): Promise<FetchEmailsResponse> => {
    try {
        const response = await api.get(ApiRoutes.EMAILS, undefined, { 
            page: page.toString(), 
            limit: limit.toString() 
        });
        
        const emails = response.data?.data?.emails || [];
        const pagination = response.data?.pagination;
        
        return {
            emails,
            pagination,
        };
    } catch (error) {
        console.error('Failed to fetch emails:', error);
        throw error;
    }
};

export const deleteEmail = async (emailId: number): Promise<boolean> => {
    try {
        const response = await api.delete(ApiRoutes.EMAILS, emailId);
        return response.data?.success === true || response.status === 200;
    } catch (error) {
        console.error('Failed to delete email:', error);
        throw error;
    }
};

